var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgQuickSendSolid = function SvgQuickSendSolid(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.75 18.971a.747.747 0 0 1-.22.56l-2 2a.75.75 0 0 1-1.06 0l-1.566-1.566-2.488 1.659A.75.75 0 0 1 3.25 21V5A2.75 2.75 0 0 1 6 2.25h10A2.75 2.75 0 0 1 18.75 5v4a.75.75 0 0 1-.75.75 2 2 0 0 0-1.63.848l-4.255 6.035a2 2 0 0 0-.366 1.153v1.185ZM7.25 7A.75.75 0 0 1 8 6.25h6a.75.75 0 0 1 0 1.5H8A.75.75 0 0 1 7.25 7Zm0 4a.75.75 0 0 1 .75-.75h6a.75.75 0 0 1 0 1.5H8a.75.75 0 0 1-.75-.75Zm0 4a.75.75 0 0 1 .75-.75h2a.75.75 0 0 1 0 1.5H8a.75.75 0 0 1-.75-.75Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.75 11.5a.75.75 0 0 0-1.356-.441l-4.572 6.286a.75.75 0 0 0 .607 1.19h2.678v3.25a.75.75 0 0 0 1.357.442l4.571-6.286a.75.75 0 0 0-.606-1.191H18.75V11.5Zm-1.893 5.536h-1.955l2.348-3.23V15.5c0 .414.336.75.75.75h1.956l-2.349 3.23v-1.694a.75.75 0 0 0-.75-.75Z",
    fill: "currentColor"
  })));
};
export default SvgQuickSendSolid;